'use strict';

import {DOM} from '../helpers/DOM.js';

export class DonationFrequency {
	constructor() {
		const donationFrequencyInputs = document.querySelectorAll(
			'input[name="donation_frequency"]'
		);
		const donationFrequencyMonthlyContainer = document.querySelector(
			'.levcharity_form__field.select_month_frequency'
		);
		const levcharityForm_FrequencyWrapper = document.querySelector(
			'.levcharity_form__frequency'
		);
		const donationFrequencyOption =
			donationFrequencyMonthlyContainer?.dataset.donationfrequencyoption;
		const frequencyDropdown = document.querySelector(
			'#donation_frequency_period'
		);
		const donationFrequencyMonthlyInput = document.querySelector(
			'#donation_frequency_monthly'
		);
		const donationFrequencyOnetimeInput = document.querySelector(
			'#donation_frequency_onetime'
		);
		const oneTimeDonationButton = document.querySelector(
			'.one_time_donation_button'
		);
		const monthlyDonationButton = document.querySelector(
			'.monthly_donation_button'
		);
		const installmentsWrapper = document.querySelector(
			'.installments-wrapper'
		);
		const unlimitedMonthOption = frequencyDropdown?.querySelector(
			'option[value="unlimited"]'
		);
		const installmentsCheckbox = document.querySelector(
			'#pay_with_installments'
		);
		const formFrequencyInput = document.querySelector(
			'input[name="form_frequency_option"]'
		);

		const predefined_amounts =
			document.querySelectorAll('.predefined_amount');
		if (
			formFrequencyInput &&
			(formFrequencyInput.value === 'monthly_only_unlimited' ||
				formFrequencyInput.value === 'monthly_without_unlimited')
		) {
			predefined_amounts?.forEach((element) => {
				const label = element.querySelector('label');
				const subLabel = document.createElement('div');
				subLabel.innerText = wp.i18n.__('/mo', 'levcharity');
				subLabel.style.color = '#828282';
				subLabel.style.fontSize = '13px';
				if (label) {
					label.appendChild(subLabel);
				}
			});
		}

		if (donationFrequencyInputs && donationFrequencyMonthlyContainer) {
			const syncFrequencyInput = (input) => {
				if (!input || input.checked) {
					return;
				}

				input.checked = true;
				DOM.triggerEvent(input, 'change', {
					isTrusted: true,
					returnValue: true,
				});
			};

			oneTimeDonationButton?.addEventListener('click', () => {
				syncFrequencyInput(donationFrequencyOnetimeInput);
			});

			monthlyDonationButton?.addEventListener('click', () => {
				syncFrequencyInput(donationFrequencyMonthlyInput);
			});

			donationFrequencyInputs?.forEach((donationFrequencyInput, key) => {
				donationFrequencyInput.addEventListener('change', (event) => {
					const value = event.target.value;
					const predefined_amounts = document.querySelectorAll('.predefined_amount');
					if (event.target.checked && value === 'monthly') {
						frequencyDropdown.style.display = '';
						frequencyDropdown.labels.forEach(label => label.style.display = '');
						if (!event.target.classList.contains('installment')) {
							if (installmentsWrapper) installmentsWrapper.style.display = 'none';

							predefined_amounts?.forEach(element => {
								const label = element.querySelector('label');
								const priceSpan = element.querySelector('.amount_value')
								const subLabel = document.createElement('div');
								subLabel.classList.add("amount_monthly_text")
								subLabel.innerText = wp.i18n.__('/mo', 'levcharity');
								subLabel.style.color = '#828282';
								subLabel.style.fontSize = '13px';
								if (priceSpan) {
									subLabel.style.display = 'inline-block';
									if (priceSpan.querySelector('.amount_monthly_text')) {
										priceSpan.querySelector('.amount_monthly_text').style.display = 'inline-block'
									} else {
										priceSpan.appendChild(subLabel)
									}
								} else if (label) {
									label.appendChild(subLabel);
								}
							});
						}
					} else {
						if (installmentsCheckbox?.checked) {
							installmentsCheckbox.click();
						}
						if (donationFrequencyOption == 'show_installments') {
							setTimeout(() => donationFrequencyMonthlyContainer.style.display = 'block');
						}

						if (installmentsWrapper) {
							installmentsWrapper.style.display = '';
						}
						predefined_amounts?.forEach((element) => {
							const label = element.querySelector('label');
							const priceSpan = element.querySelector('.amount_value')
							if (priceSpan && priceSpan.querySelector('.amount_monthly_text')) {
								priceSpan.querySelector('.amount_monthly_text').style.display = 'none'
							} else if (label) {
								label.innerHTML = label.innerHTML.replace(
									wp.i18n.__('/mo', 'levcharity'),
									''
								);
							}
						});
						frequencyDropdown.style.display = 'none';
						frequencyDropdown.labels.forEach(
							(label) => (label.style.display = 'none')
						);
					}
				});
			});
		}
		if (
			donationFrequencyOption === 'without_monthly_only' &&
			donationFrequencyMonthlyInput
		) {
			donationFrequencyMonthlyInput.click();
		}

		const defaultMonthlyOption = document.querySelector(
			'.donation_frequency_options_wrapper'
		);

		if (defaultMonthlyOption?.dataset?.default === 'monthly') {
			const monthlyOption = document.getElementById(
				'donation_frequency_monthly'
			);
			if (monthlyOption) {
				monthlyOption.click();
			}
		}

		installmentsCheckbox?.addEventListener('change', (event) => {
			if (donationFrequencyInputs) {
				if (event.target.checked) {
					frequencyDropdown.style.display = '';
					frequencyDropdown.labels.forEach(
						(label) => (label.style.display = '')
					);
					donationFrequencyInputs.forEach((donationFrequencyInput) => {
						if (
							event.target.checked &&
							donationFrequencyInput.getAttribute('value') ===
							'monthly'
						) {
							frequencyDropdown.selectedIndex = 1;
							unlimitedMonthOption.setAttribute('disabled', '');
							unlimitedMonthOption.setAttribute('hidden', '');
						}
					});
					const hiddenFrequencyInput = DOM.el('input[type="hidden"][name="donation_frequency"]');
					if (hiddenFrequencyInput) {
						hiddenFrequencyInput.value = 'monthly';
					}
				} else {
					donationFrequencyInputs.forEach((donationFrequencyInput) => {
						if (
							donationFrequencyInput.getAttribute('value') ===
							'onetime'
						) {
							frequencyDropdown.selectedIndex = 1;
							unlimitedMonthOption.removeAttribute('disabled');
							unlimitedMonthOption.removeAttribute('hidden');
						}
					});
					DOM.triggerEvent(frequencyDropdown, 'change', {
						isTrusted: true,
						returnValue: true,
					});
					const hiddenFrequencyInputOnetime = DOM.el('input[type="hidden"][name="donation_frequency"]');
					if (hiddenFrequencyInputOnetime) {
						hiddenFrequencyInputOnetime.value = 'onetime';
					}
					frequencyDropdown.selectedIndex = 1;
					donationFrequencyInputs.forEach((donationFrequencyInput) => {
						donationFrequencyInput.removeAttribute('disabled');
						if (levcharityForm_FrequencyWrapper) {
							levcharityForm_FrequencyWrapper.style.display = 'block';
						}

						if (
							donationFrequencyInput.getAttribute('value') ===
							'monthly'
						) {
							donationFrequencyInput.classList.remove(
								'installment'
							);
						}

						// frequencyDropdown.innerHTML = frequencyDropdown.innerHTML;
					});
					unlimitedMonthOption.removeAttribute('disabled');
					unlimitedMonthOption.removeAttribute('hidden');
					frequencyDropdown.style.display = 'none';
					frequencyDropdown.labels.forEach(
						(label) => (label.style.display = 'none')
					);
				}
			}
		});
	}
}
